<template>
  <div>
    <div class="system-stats-row">
      <StatsCard
        title="Average Public Solve Speed"
        desc="Your average Public Solve Speeds."
        :attr1="getPublicAvgSpeed"
        attr2="Seconds per solvee"
      ></StatsCard>
      <StatsCard
        title="Average Private Solve Speed"
        desc="Your average Private Solve Speeds."
        :attr1=getPrivateAvgSpeed
        attr2="Seconds per solve"
      ></StatsCard>
      <StatsCard
        title="Average Factory Solve Speeds"
        desc="Your average Factory Solve Speeds."
        :attr1=getFactoryAvgSpeed
        attr2="Seconds per solve"
      ></StatsCard>
    </div>
    <SolvingStatsTable></SolvingStatsTable>
  </div>
</template>


<script>
import StatsCard from "../../../../components/user/captcha/stats/StatsCard";
import SolvingStatsTable from "../../../../components/user/captcha/stats/SolvingStatsTable";
export default {
  components: {
    StatsCard,
    SolvingStatsTable,
  },
  computed: {
    getPublicAvgSpeed() {
      return this.$store.getters["userStore/getPublicAvgSpeed"];
    },
    getPrivateAvgSpeed() {
      return this.$store.getters["userStore/getPrivateAvgSpeed"];
    },
    getFactoryAvgSpeed() {
      return this.$store.getters["userStore/getFactoryAvgSpeed"];
    },
  },
  mounted() {
    // console.log(this.getPublicAvgSpeed);
  },
};
</script>

<style scoped>
.system-stats-row {
  display: flex;
  justify-content: space-between;
}
@media only screen and (max-width: 1250px) {
  .system-stats-row {
    flex-wrap: wrap !important;
  }
  .stats-card-main {
    max-width: 44% !important;
    width: 44% !important;
    flex: 44% !important;
    margin-bottom: 32px !important;
  }
}

@media only screen and (max-width: 792px) {
  .system-stats-row {
    flex-wrap: wrap !important;
  }
  .stats-graph-main {
    flex: 100% !important;
    max-width: 100% !important;
    width: 100% !important;
  }
  .captcha-solving-stats-actual-graphs-row {
    flex-wrap: wrap !important;
  }
}

@media only screen and (max-width: 600px) {
  .stats-card-main {
    max-width: 100% !important;
    width: 100% !important;
    flex: 100% !important;
    margin-bottom: 32px !important;
  }
}
</style>